import BaseAPIService from './BaseAPIService';
import experienceSendMessageToUser from '../graphql/mutations/experienceSendMessageToUser.gql';

export default class ExperienceChatService extends BaseAPIService {
	constructor() {
		super();
	}

	async experienceSendMessageToUser(experienceId, userId, message) {
		const mutation = experienceSendMessageToUser;
		const variables = {
            experienceId,
            userId,
            message
		};
		const result = await this.mutate({
			mutation,
			variables,
		});
		return result.data.experienceSendMessageToUser;
	}
}
